import {http} from "../http";
import {Company} from "../company";

export interface TransactionsCount{
    status : string;
    count : number;
}

export const getWidgetTransactions = async (startdate: string, enddate: string, account?: string): Promise<TransactionsCount[]> => {
    const body = { startdate, enddate, ...(account ? { account } : {}) };
    const { data } = await http.post<any>(`transaction/transfer-count-summary`, body);
    return data;
};